module.exports = __webpack_public_path__ + "static/media/health.f9bef88d.webp";